export default "./images/survio-PAblc-assets-workspaces.svg";